import firebase from './index'

export function firebaseFetchOneSensor(factoryID, sensorID) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child('mekh')
      .child(factoryID)
      .child('devices')
      .child(sensorID)
      .once('value')
      .then(snap => {
        resolve(snap.val())
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseMonitorOneSensorDisplay(factoryID, sensorID, cb) {
  firebase
    .database()
    .ref()
    .child('mekh')
    .child(factoryID)
    .child('display')
    .child(sensorID)
    .on('value', snap => {
      cb(snap.val())
    })
}

export function firebaseMonitorOneSensorStatus(factoryID, sensorID, cb) {
  firebase
    .database()
    .ref()
    .child('mekh')
    .child(factoryID)
    .child('devices')
    .child(sensorID)
    .on('value', snap => {
      cb(snap.val())
    })
}

export function firebaseCreateSensor(factoryID, newSensor) {
  return firebase
    .database()
    .ref()
    .child('mekh')
    .child(factoryID)
    .child('devices')
    .push()
    .set(newSensor)
}

export function firebaseUpdateSensor(factoryID, sensorID, updatedSensor) {
  return firebase
    .database()
    .ref()
    .child('mekh')
    .child(factoryID)
    .child(`devices`)
    .child(sensorID)
    .update(updatedSensor)
}

export function firebaseDeleteSensor(factoryID, sensorID) {
  return firebase
    .database()
    .ref()
    .child('mekh')
    .child(factoryID)
    .child(`devices`)
    .child(sensorID)
    .remove()
}
